import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "v1-providers__title",
  "data-testid": "v1-providers-title"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoading = _resolveComponent("PageLoading")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ProviderAmountSummary = _resolveComponent("ProviderAmountSummary")!
  const _component_ProviderCardList = _resolveComponent("ProviderCardList")!
  const _component_V1ScreenScaffold = _resolveComponent("V1ScreenScaffold")!
  const _component_NoPayments = _resolveComponent("NoPayments")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_PageLoading, { key: 0 }))
      : (_ctx.error)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, { key: 1 }))
        : (_ctx.providers && _ctx.providers.sections.length > 0)
          ? (_openBlock(), _createBlock(_component_V1ScreenScaffold, {
              key: 2,
              "next-disabled": !_ctx.canContinue,
              "data-testid": "v1-providers",
              onNext: _ctx.handleContinue
            }, {
              subtitle: _withCtx(() => [
                (_ctx.amountDisplay)
                  ? (_openBlock(), _createBlock(_component_ProviderAmountSummary, {
                      key: 0,
                      label: _ctx.labels?.paymentAmount || '',
                      amount: _ctx.amountDisplay,
                      "next-payment": _ctx.nextPaymentLine || '',
                      "test-id": "v1-providers-amount",
                      "next-payment-test-id": "v1-providers-next-payment"
                    }, null, 8, ["label", "amount", "next-payment"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.providers.title), 1),
                _createVNode(_component_ProviderCardList, {
                  items: _ctx.cardItems,
                  "selected-key": _ctx.selectedCardKey,
                  onSelect: _ctx.onCardSelect
                }, null, 8, ["items", "selected-key", "onSelect"])
              ]),
              _: 1
            }, 8, ["next-disabled", "onNext"]))
          : (_openBlock(), _createBlock(_component_NoPayments, { key: 3 })),
    _createVNode(_component_Modal, {
      "model-value": _ctx.activePopup !== null,
      title: _ctx.popupTitle,
      "primary-text": _ctx.popupPrimaryText,
      "secondary-text": _ctx.popupSecondaryText || undefined,
      placement: "bottom",
      "data-testid": "v1-provider-popup",
      onPrimary: _ctx.onPopupPrimary,
      onSecondary: _ctx.onPopupSecondary,
      "onUpdate:modelValue": _ctx.onPopupModel
    }, {
      default: _withCtx(() => [
        (_ctx.activePopup && _ctx.activePopup.notice)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.activePopup.notice.body), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value", "title", "primary-text", "secondary-text", "onPrimary", "onSecondary", "onUpdate:modelValue"]),
    _createVNode(_component_Modal, {
      "model-value": _ctx.showCountryNotice,
      title: _ctx.countryNoticeTitle,
      "primary-text": _ctx.countryNoticePrimaryText,
      "secondary-text": _ctx.countryNoticeSecondaryText || undefined,
      placement: "bottom",
      "data-testid": "v1-country-notice-popup",
      onPrimary: _ctx.dismissCountryNotice,
      onSecondary: _ctx.onCountryNoticeSecondary,
      "onUpdate:modelValue": _ctx.onCountryNoticeModel
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.countryNoticeBody), 1)
      ]),
      _: 1
    }, 8, ["model-value", "title", "primary-text", "secondary-text", "onPrimary", "onSecondary", "onUpdate:modelValue"])
  ], 64))
}